import { media, styled, typography } from '@pulse-web-ui/theme';

export const StatusWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  ${media.desktop} {
    flex-direction: row;
  }
`;

export const StepWrapper = styled.div`
  display: flex;
  align-items: baseline;
`;

export const StepNumber = styled.div<{
  $isActive?: boolean;
  $isDisabled?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  color: ${({ theme, $isActive }) =>
    $isActive ? theme.colors.text.inverse : theme.colors.text.primary};
  background: ${({ $isDisabled, $isActive, theme }) =>
    $isActive
      ? theme.colors.accent.action.normal
      : $isDisabled
        ? theme.colors.neutral[10]
        : theme.colors.accent.action.clarified};
`;

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const StepTitle = styled.p`
  color: ${({ theme }) => theme.colors.text.primary};
  margin-bottom: 4px;
`;

export const StepDescription = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
`;

export const StepDate = styled.div`
  ${typography.regular12};
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-left: 4px;
`;

export const StepSeparator = styled.div<{ $withOffsetLeft?: boolean }>`
  display: flex;
  flex: 1;
  width: 1px;
  min-height: 28px;
  margin: -6px 20px 6px;
  background-color: ${({ theme }) => theme.colors?.neutral[30]};

  ${media.desktop} {
    height: 1px;
    min-height: initial;
    margin: 20px 12px;
    margin-left: ${({ $withOffsetLeft }) => ($withOffsetLeft ? '-60px' : 0)};
  }
`;
